import { render, staticRenderFns } from "./Aberto.vue?vue&type=template&id=6e7ab08b"
import script from "./Aberto.vue?vue&type=script&lang=js"
export * from "./Aberto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports